import { Evaluation } from 'lib/types/models';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export type EvaluationRow = {
  id: number;
  label: string;
  businessName: string;
  businessIdentifier: string;
  createdAt: Date;
  engineName: string;
  evaluationId: number;
  status: string;
};

export async function fetchCreditLineEvaluations(
  dispatch: Dispatch,
): Promise<EvaluationRow[]> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/product/creditLine`,
    dispatch,
  });
  if (response) return response.data;
  return [];
}

export type EvaluationDetail = Evaluation & {
  businessName: string;
  businessIdentifier: string;
};

export async function fetchCreditLineEvaluation(
  dispatch: Dispatch,
  id: number,
): Promise<EvaluationDetail | undefined> {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/product/creditLine/${id}`,
    dispatch,
  });
  if (response) return response.data;
}

export const fetchDecisionEnginesAvailables = async (
  dispatch: Dispatch,
  revisionObjective: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/availables?revisionObjective=${revisionObjective}`,
    dispatch,
  });
  if (response) return response.data;
};

export const createCreditLineEvaluation = async (
  dispatch: Dispatch,
  payload: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: 'internal/decisionEngine/creditLine',
    data: payload,
    dispatch,
  });
  if (response) return response.data;
};

export const selectDecisionEngineAsDefault = async (
  dispatch: Dispatch,
  engineId: number,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/decisionEngine/${engineId}/default`,
    dispatch,
  });
  if (response) return response.data;
};

export const getCreditLineFactoringSelectedDecisionEngines = async (
  dispatch: Dispatch,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/decisionEngine/creditLine/factoring/selected`,
    dispatch,
  });
  if (response) return response.data;
};
